import React from "react";
import { useSearchParams } from "react-router-dom";
import { useStreamCategories } from "./useStreamCategories";
import { useStreamBracket } from "./useStreamBracket";
import { useTransparentBody } from "./useTransparentBody";
import StreamControls from "./StreamControls";
import { deriveRanking } from "../../utils/ranking";

// Page overlay stream — classement / podium (fond transparent, source
// navigateur OBS). URL : /stream/ranking?category=women1 (&hide=1 une
// fois configurée). Réutilise deriveRanking() (même logique que
// RankingTable.jsx) — se met donc à jour progressivement au fil du
// bracket, pas seulement une fois la finale jouée.

const MEDAL = { 1: "🥇", 2: "🥈", 3: "🥉" };

export default function StreamRanking() {
    useTransparentBody();
    const [params, setParams] = useSearchParams();
    const category = params.get("category") || "";
    const hidden = params.get("hide") === "1";

    const categories = useStreamCategories();
    const bracket = useStreamBracket(category, 2000);
    const ranking = bracket ? deriveRanking(bracket) : [];

    const podium = ranking.filter((r) => r.place <= 3);
    const rest = ranking.filter((r) => r.place > 3);

    const setCategory = (value) => {
        const next = new URLSearchParams(params);
        if (value) next.set("category", value);
        else next.delete("category");
        setParams(next, { replace: true });
    };

    return (
        <div style={{ minHeight: "100vh", background: "transparent", padding: 24, fontFamily: "sans-serif" }}>
            <StreamControls categories={categories} category={category} onCategoryChange={setCategory} hidden={hidden} />

            {ranking.length > 0 && (
                <div style={{ maxWidth: 560 }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 14 }}>
                        {podium.map((r) => (
                            <div
                                key={r.fiscode || r.place}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 14,
                                    background: "rgba(0,0,0,0.6)",
                                    borderRadius: 10,
                                    padding: "10px 16px",
                                }}
                            >
                                <div style={{ fontSize: 30 }}>{MEDAL[r.place] || r.place}</div>
                                <div style={{ fontSize: 26, fontWeight: 800, color: "#fff", textShadow: "0 2px 6px rgba(0,0,0,0.85)" }}>
                                    [{r.bib}] {r.name}
                                </div>
                                <div style={{ fontSize: 16, color: "#ccc", marginLeft: "auto" }}>{r.nation}</div>
                            </div>
                        ))}
                    </div>

                    {rest.length > 0 && (
                        <div style={{ background: "rgba(0,0,0,0.45)", borderRadius: 10, padding: "8px 16px" }}>
                            {rest.map((r) => (
                                <div
                                    key={r.fiscode || r.place}
                                    style={{ display: "flex", gap: 12, padding: "3px 0", color: "#fff", fontSize: 16 }}
                                >
                                    <div style={{ width: 28, fontWeight: 700 }}>{r.place}</div>
                                    <div>
                                        [{r.bib}] {r.name}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {category && ranking.length === 0 && <div style={{ color: "#fff" }}>Classement pas encore disponible.</div>}
        </div>
    );
}
